import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "@/lib/router-compat";
import bananaBallAsset from "@/assets/projects/bananaballnation.webp.asset.json";
import bfwAsset from "@/assets/projects/blackfamilyweekend.webp.asset.json";
import jcpsAsset from "@/assets/projects/jcpsinsider.webp.asset.json";

const bananaBallImg = bananaBallAsset.url;
const bfwImg = bfwAsset.url;
const jcpsImg = jcpsAsset.url;

const projects = [
  {
    title: "JCPS Insider",
    description: "Independent JCPS News, Insights & Resources",
    category: "Website Design & Development",
    image: jcpsImg,
    url: "https://neti.us/ALrmxA",
  },
  {
    title: "Banana Ball Nation",
    description: "The Fan Home for the Wildest Show in Sports",
    category: "Website Design & Development",
    image: bananaBallImg,
    url: "https://neti.us/usB14j",
  },
  {
    title: "Black Family Weekend",
    description: "Celebrating Black Family, Culture & Community",
    category: "Website Design & Development",
    image: bfwImg,
    url: "https://neti.us/pA3uay",
  },
];

const ProjectsSection = () => {
  return (
    <section className="py-16 border-t border-border" aria-labelledby="projects-title">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <h2 id="projects-title" className="text-3xl md:text-4xl font-bold mb-4">
            Recent Projects
          </h2>
          <p className="text-muted-foreground text-lg">
            A selection of high-performance websites we've delivered.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          {projects.map((project, index) => (
            <a
              key={index}
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-secondary/50 border border-border rounded-lg overflow-hidden hover:bg-secondary/70 transition-colors animate-fade-in block ring-1 ring-white/[0.08] dark:ring-white/[0.12]"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="aspect-video bg-muted flex items-center justify-center overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                  width={640}
                  height={360}
                />
              </div>
              <div className="p-6">
                <span className="text-xs uppercase tracking-wider text-primary font-medium">
                  {project.category}
                </span>
                <h3 className="text-xl font-semibold mt-2 mb-2">{project.title}</h3>
                <p className="text-muted-foreground">{project.description}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center">
          <Button asChild variant="outline" size="lg">
            <Link to="/projects">
              MORE PROJECTS <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
